module.exports = __webpack_public_path__ + "media/images/icons/single-user-plus-f3f050db41da8b9fafb8469a24c81433.svg";